import { UIHeading5, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ClientComment.css';

interface IClientCommentProps {
  text: string;
  title?: string;
}

export const ClientComment = ({ title, text }: IClientCommentProps) => {
  return (
    <div className={styles['container']}>
      {title && <UIHeading5>{title}</UIHeading5>}
      <UIText2>{text}</UIText2>
    </div>
  );
};
